import { PropertyType } from 'components/filters/types';
import { Route } from 'config/routes';
import { DealType } from './entities';
import { getPluralPropertyTypeName } from './get-plural-property-type-name';
import { dealTypeInvertedDict } from 'consts/dictionaries';

export const buildPropertyTypeBasedPath = (
    routeName: Route.Search | Route.SearchCommercial,
    propertyType: PropertyType,
    dealType: DealType,
    term: string
): string | null => {
  const pluralPropertyTypeName = getPluralPropertyTypeName(propertyType);
  if (!pluralPropertyTypeName) return null;
  const dealTypeFromDict = dealTypeInvertedDict[dealType];

  let path: string;
  switch (routeName) {
    case Route.Search:
      path = `/${pluralPropertyTypeName}-for-${dealTypeFromDict}/${term}`;
      break;
    case Route.SearchCommercial:
      path = `/commercial/${pluralPropertyTypeName}-for-${dealTypeFromDict}/${term}`;
      break;
  }

  return encodeURI(path);
};
